import {
  OwnUpSmallBodyMedium,
  OwnUpSmallSubheadlineMedium,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';

import { useDownPayment } from '../data/dataProvider';

const SummaryContainer = styled.div`
  display: flex;

  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    column-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(8)}px;
  }
`;

const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1)}px;

  flex-basis: 50%;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    flex-basis: auto;
  }
`;

const ResultValue = styled(OwnUpSmallSubheadlineMedium)`
  padding-top: 0 !important;
`;

export const SummaryImpl = ({ downPaymentPercent }: { downPaymentPercent: number }) => {
  return (
    <SummaryContainer>
      <SummaryItem>
        <ResultValue variant="h2">{downPaymentPercent}%</ResultValue>
        <OwnUpSmallBodyMedium variant="body1">Down payment</OwnUpSmallBodyMedium>
      </SummaryItem>
    </SummaryContainer>
  );
};

export const SummaryNumbers = () => {
  const {
    state: { downPaymentPercent }
  } = useDownPayment();

  return <SummaryImpl downPaymentPercent={downPaymentPercent} />;
};
